import { useEffect } from 'react';
import type { GuaItem } from '@/mocks/guatian';

interface Props {
  item: GuaItem | null;
  onClose: () => void;
}

export default function ArticleModal({ item, onClose }: Props) {
  useEffect(() => {
    if (!item) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [item, onClose]);

  if (!item) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-foreground-950/60 p-4 backdrop-blur-sm md:items-center md:p-6" role="dialog" aria-modal="true" aria-label={item.title}>
      <div className="animate-pop relative w-full max-w-2xl overflow-hidden rounded-3xl bg-background-50">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-foreground-800 shadow-sm transition hover:bg-primary-500 hover:text-background-50"
          aria-label="关闭"
        >
          <i className="ri-close-line text-xl" aria-hidden="true" />
        </button>

        <div className="relative aspect-[16/8] w-full">
          <img src={item.image} alt={item.title} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <div className="mb-2 flex items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
                <i className="ri-fire-line" aria-hidden="true" /> {item.tag}
              </span>
              <span className="rounded-md bg-background-50/80 px-2 py-0.5 text-xs text-foreground-700">{item.category}</span>
            </div>
            <h2 className="text-lg font-semibold leading-snug text-background-50 md:text-2xl">{item.title}</h2>
          </div>
        </div>

        <div className="px-5 py-5 md:px-7 md:py-6">
          <div className="mb-5 flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-4 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-user-heart-line" aria-hidden="true" /> {item.author}
            </span>
            <span className="flex items-center gap-3">
              <span className="inline-flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{item.time}</span>
              <span className="inline-flex items-center gap-1 text-primary-600"><i className="ri-flashlight-fill" aria-hidden="true" />{item.heat} 热度</span>
            </span>
          </div>

          {item.detail.map((p, i) => (
            <p key={i} className="mb-4 text-sm leading-relaxed text-foreground-700 last:mb-0 md:text-[15px]">
              {p}
            </p>
          ))}

          <div className="mt-6 rounded-2xl bg-accent-100/70 p-4 text-xs leading-relaxed text-foreground-600 md:text-[13px]">
            <span className="font-medium text-accent-700">· 免责声明 ·</span>
            本文为瓜田网基于公开信息整理的娱乐行业动态观察，涉及个人内容均以多方信源与待证标注呈现，不构成对任何真实个人的定性报道，请理性看待。
          </div>
        </div>
      </div>
    </div>
  );
}